import { Component, OnInit } from '@angular/core';
import { GetService } from 'app/core/get.service';
import { DatePipe } from '@angular/common';
import { AppMemoryService } from 'app/core/app-memory.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { AdminReportService } from 'app/core/admin-report.service';
import { saveAs as importedSaveAs } from 'file-saver';
import {environment} from '../../../environments/environment';
interface ActiveFiltersType {
  [key: string]: number;
}

interface SpecificValuesType {
  [key: string]: (string | number)[];
}

@Component({
  selector: 'app-weight-reporting',
  templateUrl: './weight-reporting.component.html',
  styleUrls: ['./weight-reporting.component.less']
})
export class WeightReportingComponent implements OnInit {
  public activeFilters: ActiveFiltersType = {} as ActiveFiltersType;
  public specificValues: SpecificValuesType = {} as SpecificValuesType;
  public horses: any[] = [] as any[];
  public reports: any[] = [] as any[];
  public showDateRange = false;
  public setStartDateInput:any = null;
  public setEndDateInput:any = null;
  public currentWidth:any = null;
  public emailSent = false;
  public offset: { [key: string]: number } = {} as { [key: string]: number };
  public translation = {};
  public limit: { [key: string]: number } = {} as { [key: string]: number };
  public reportsKeys: any[] = [] as any[];
  public sorting: { [key: string]: { field: string, order: string } } = {} as { [key: string]: { field: string, order: string } };
  public datePickerPeriodFrom = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input: ''/*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean
  };
  public weights:any[] = [];

  public datePickerPeriodTo = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input: ''/*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    selectedDate: '' as String,
    isActive: false as boolean
  };
  public datePickerMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };
  public period: { type: string, [key: string]: string } = {} as { type: string, [key: string]: string };
  public periodPayload = {};
  public periodSelected = false;
  public serverError = null;
  public dateRangeRequired = false;
  public dateRangeErrorMessage: {from?: string, due?: string, date?: string} = {} as {from?: string, due?: string, date?: string};
  constructor(private getService: GetService,
    private datePipe: DatePipe,
    private notificationsService: NotificationsService,
    public appMemory: AppMemoryService,
    public translateService: TranslateService,
    private adminReportService: AdminReportService ) {
      this.getTranslation();
  }

  ngOnInit() {
    this.getService.getAllHorses().then(res => this.horses = res);
  }

  // VS:Insert data weights from horses and dates
  public lineChartData:Array<any> = [
    // {data: [65, 59, 80, 81, 56, 55, 40], label: 'Weights'},
    // {data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B'},
    // {data: [18, 48, 77, 9, 100, 27, 40], label: 'Series C'}
  ];
  public lineChartLabels:Array<any> = [];
  public lineChartOptions:any = {
    responsive: true
  };
  // VS:Manage numbers of lines using this array
  public lineChartColors:Array<any> = [
    { // Red line
      backgroundColor: 'transparent',
      borderColor: '#e83a4e',
      pointBackgroundColor: '#e83a4e',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    // { // dark grey
    //   backgroundColor: 'rgba(77,83,96,0.2)',
    //   borderColor: 'rgba(77,83,96,1)',
    //   pointBackgroundColor: 'rgba(77,83,96,1)',
    //   pointBorderColor: '#fff',
    //   pointHoverBackgroundColor: '#fff',
    //   pointHoverBorderColor: 'rgba(77,83,96,1)'
    // },
    // { // grey
    //   backgroundColor: 'rgba(148,159,177,0.2)',
    //   borderColor: 'rgba(148,159,177,1)',
    //   pointBackgroundColor: 'rgba(148,159,177,1)',
    //   pointBorderColor: '#fff',
    //   pointHoverBackgroundColor: '#fff',
    //   pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    // }
  ];
  public lineChartLegend:boolean = true;
  public lineChartType:string = 'line';

  // public randomize():void {
  //   let _lineChartData:Array<any> = new Array(this.lineChartData.length);
  //   for (let i = 0; i < this.lineChartData.length; i++) {
  //     _lineChartData[i] = {data: new Array(this.lineChartData[i].data.length), label: this.lineChartData[i].label};
  //     for (let j = 0; j < this.lineChartData[i].data.length; j++) {
  //       _lineChartData[i].data[j] = Math.floor((Math.random() * 100) + 1);
  //     }
  //   }
  //   this.lineChartData = _lineChartData;
  // }

  assignChartData(id?:number) {
    return this.getService.getWeights({id}).then(res => {
      if (res && res.weight && res.weight.length) {
        this.weights = this.weights.concat(res.weight);
        this.lineChartData = [{data: res.weight.map(el => el.weight_for_graph), label: 'Weights'}];
        this.lineChartLabels = res.weight.map(el => el.date);
      }
    });
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {boolean}
   */
  checkPeriodValidity(): boolean {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    if (this.period.type !== undefined) {
      if (this.period.type.length) {
        return false;
      } else {
        if (this.period.start && this.period.end && this.period.start > this.period.end) {
          this.dateRangeErrorMessage = {
            from: 'OTHER.periodFromGreaterPeriodDue',
            due: 'OTHER.periodFromGreaterPeriodDue'
          };
        }
        // else if (new Date(this.period.start).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
        //   this.dateRangeErrorMessage = {
        //     from: `OTHER.dateExceededReg`,
        //     date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
        //   };
        // } else if (new Date(this.period.end).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
        //   this.dateRangeErrorMessage = {
        //     due: `OTHER.dateExceededReg`,
        //     date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
        //   };
        // }
        else {
          this.dateRangeErrorMessage = {};
        }

        return !(this.period.start <= this.period.end);
      }
    }
  }

  /**
 * Set selected date from dateicker
 * @param {({ selectedDate: (Date | String), currentDate: (Date | String) })} destination
 * @param {*} payloadProperty
 * @param {Date} date
 */
selectDate(destination: { selectedDate: (Date | String), currentDate: (Date | String) }, payloadProperty, date: Date): void {
  if (this.serverError) {
    this.serverError[payloadProperty] = null;
  }
  if (destination && date) {
    destination.selectedDate = this.datePipe.transform(new Date(date), 'yyyy-MM-dd');
    destination.currentDate = date;
    this.period[payloadProperty] = destination.selectedDate.toString();
    if (payloadProperty === 'start') {
      this.datePickerPeriodFrom.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
    } else {
      this.datePickerPeriodTo.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
    }
    this.offset = {};
  }
}

  /**
   * Get and parse registration date of the user
   * @returns {Date}
   */
  getRegistrationDate(): Date{
    return new Date(this.appMemory.user.created_at);
  }

  /**
   * Transforms object to FormData
   * @param {Object} obj
   * @param {FormData} [form]
   * @param {((String | Number))} [namespace]
   * @returns {FormData}
   */
  objectToFormData(object: Object, form?: FormData, namespace?: string): FormData {
    const formData = form || new FormData();
    for (const property in object) {
      if (!object.hasOwnProperty(property) || !object[property]) {
        continue;
      }
      const formKey = namespace ? `${namespace}[${property}]` : property;
      if (object[property] instanceof Date) {
        formData.append(formKey, object[property].toISOString());
      } else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
        this.objectToFormData(object[property], formData, formKey);
      } else {
        formData.append(formKey, object[property]);
      }
    }
    return formData;
  }


  /**
   * Organize the response
   * @param {(Object | any)} reports
   */
  restructureReports(res: Object | any, sort?: boolean): void {
      if (res && res.weight && res.weight.length) {
          this.weights = this.weights.concat(res.weight);
          this.lineChartData = [{data: res.weight.map(el => el.weight_for_graph), label: 'Weights'}];
          this.lineChartLabels = res.weight.map(el => el.date || el.created_at);
      }
  }

  /**
   * Gather all data for payload and prepare for request
   * @returns {FormData}
   */
  formPayload(sort?: boolean): FormData {
    const tempSpecific = Object.assign({}, this.specificValues);
    if (this.activeFilters['in_horses'] === 1) {
      tempSpecific['horses_id'] = this.specificValues['horses_id'];
    } else {
      tempSpecific['horses_id'] = [];
    }

    let page: any = { limit: this.limit, offset: this.offset };
    if (sort) {
      page = {
        limit: this.offset,
        offset: 0
      };
    }

    // const sorting = { 'note': { 'order':  'asc', 'field': 'type' } };
    const payload: Object = Object.assign({},
      this.activeFilters,
      tempSpecific,
      { period: this.periodPayload },
      { limit: page.limit },
      { offset: page.offset },
      { sorting: this.sorting });
    return this.objectToFormData(payload);
  }

  /**
   * Confirm selected period from date range modal
   */
  confirmPeriod(): void {
    this.periodPayload = Object.assign({}, this.period);
    this.dateRangeRequired = false;
    this.periodSelected = true;
    this.emailSent = false;
  }

  /**
   * Get the reports according to current filter
   */
  getReports(sort?: boolean): void {
    this.dateRangeRequired = false;
    if (!this.period.type && !(this.period.start && this.period.end)) {
      this.notificationsService.error(
        `${this.translation['dateRange']}`,
        `${this.translation['dateRange']} ${this.translation['isRequired']}`
      );
      this.dateRangeRequired = true;
      return;
    }
    const payload: FormData = this.formPayload(sort);
    this.emailSent = false;
    this.adminReportService.postWeightAdministrativeReports(payload).then(res => this.restructureReports(res, sort));
  }

  // events
  public chartClicked(e:any):void {
    // console.log(e);
  }

  public chartHovered(e:any):void {
    // console.log(e);
  }

  /**
   * Check if any filter is active
   * @returns {boolean}
   */
  checkActiveFilters(): boolean {
    if (Object.keys(this.activeFilters).length) {
      const values: number[] = Object.keys(this.activeFilters).map(key => this.activeFilters[key]);
      return values.some(el => el === 1);
    }
    return false;
  }

  /**
   * Activate a filter
   * @param {boolean} event
   * @param {string} key
   */
  onChecked(event: boolean, key: string): void {
    this.activeFilters[`in_${key}`] = +event;
    console.log(this.activeFilters);
    this.offset = {};
    this.emailSent = false;
  }

  /**
   *  Get specific selected values from fitlers
   * @param {(string|number)[]} event
   * @param {(string|number)} key
   * @param {string} [suffix]
   */
  onSelect(event: (string | number | any)[], key: (string | number), suffix?: string): void {
    this.specificValues[key + suffix] = event;
    this.offset = {};
    this.emailSent = false;
    if (event.length) {
      this.assignChartData(event[0])
    }
  }

    public exporting = false;

    downloadWeightReport(type: 'csv' | 'pdf'): Promise<void> {
        this.exporting = true;
        const criteria: FormData = this.formPayload();
        const payload: FormData = this.objectToFormData({file_type: type}, criteria);

        return this.adminReportService.downloadWeightReport(payload).then(res => {
            this.exporting = false;
            let file: Blob;
            let fileType: String;
            if (type === 'csv') {
                file = new Blob([res], {type: 'text/csv;charset=utf-8'});
                fileType = 'csv';
            } else {
                file = res;
                fileType = 'pdf';
            }
            importedSaveAs(file, `report.${fileType}`);
        }, err => {
            this.exporting = false;
        });
    }

    public emailSending = false;

    sendOnEmail(): Promise<void> {
        this.emailSending = true;
        const payload: FormData = this.formPayload();
        return this.adminReportService.sendWeightMail(payload).then(res => {
            this.emailSent = true;
            this.emailSending = false;
            this.notificationsService.success(
                `${this.translation['sendEmailReport']}`,
                `${this.translation['sentEmailReport']}`
            );
        }, err => {
            this.emailSending = false;
            this.notificationsService.error(
                `${this.translation['sendEmailReport']}`,
                `${this.translation['errorOccurred']}`
            );
        });
    }

    getTranslation() {
    this.translateService.get('REPORT.sendEmailReport').subscribe((word: string) => {
      this.translation['sendEmailReport'] = word;
    });
    this.translateService.get('REPORT.sentEmailReport').subscribe((word: string) => {
      this.translation['sentEmailReport'] = word;
    });
    this.translateService.get('OTHER.errorOccurred').subscribe((word: string) => {
      this.translation['errorOccurred'] = word;
    });
    this.translateService.get('REPORT.dateRange').subscribe((word: string) => {
      this.translation['dateRange'] = word;
    });
    this.translateService.get('CORE.isRequired').subscribe((word: string) => {
      this.translation['isRequired'] = word;
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/weight-reporting/weight-reporting.component.ts